import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "neuroeq_token";
export const ADMIN_TOKEN_KEY = "neuroeq_admin_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const isAdmin = (config.url || "").startsWith("/admin");
  const tk = isAdmin ? localStorage.getItem(ADMIN_TOKEN_KEY) : localStorage.getItem(TOKEN_KEY);
  if (tk) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tk}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem(ADMIN_TOKEN_KEY);
        window.location.href = "/admin/login";
      } else if (!path.startsWith("/login") && !path.startsWith("/admin") && path !== "/") {
        localStorage.removeItem(TOKEN_KEY);
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
